module.exports = __webpack_public_path__ + "img/pay-done.564d93ad.png";